import { Form, Select } from 'antd';
import { SimpleTable } from '@/components/simple-table';
import {
  AllowancesColumns,
  OtherColumns,
} from '../../../table/form-table-columns';
import VariationsInputSection from '../../VariationsInputSection';
import { useEmployeeGeneralDataForm } from '../EmployeeGeneralDataFormContext';
import EmployeeAllowancesProfilePanel from './EmployeeAllowancesProfilePanel';

/** Employment allowances, bonus basis and variations. */
export default function EmployeeAllowancesFields() {
  const {
    COMPANY_DATA,
    bonusBasisKeys,
    bonusBasisState,
    companyDataIsLoading,
    form,
    formFields,
    isEdited,
    isNonEmployment,
    isProfile,
    readOnly,
    sectionClass,
    t,
  } = useEmployeeGeneralDataForm();

  return (
    <>
      {/* Employment allowances + variations (meal/holiday/travel/WFH, bonus,
          suspension, NMB). These are employment-relationship benefits — special
          employment is paid a fee via OZ, so the whole block is hidden. */}
      {!isNonEmployment && (
        <div className={sectionClass('primanja')}>
          {isProfile ? (
            <EmployeeAllowancesProfilePanel />
          ) : (
            <>
              <hr className="my-5" />

              <SimpleTable
                isLoading={companyDataIsLoading}
                data={COMPANY_DATA.calculationMethods}
                columns={() =>
                  AllowancesColumns({ form, formFields, isEdited })
                }
              />

              <hr className="my-5" />

              <SimpleTable
                isLoading={companyDataIsLoading}
                data={COMPANY_DATA.otherAllowancesData}
                columns={() => OtherColumns({ form, formFields, isEdited })}
              />
            </>
          )}

          {bonusBasisState?.visible && (
            <Form.Item
              name={bonusBasisKeys}
              label={t('bonusBasis', { ns: 'forms' })}
              tooltip={t('bonusBasisTooltip', { ns: 'forms' })}
              className={isProfile ? 'mt-4 max-w-[560px]' : 'mt-5'}
            >
              <Select
                className="w-full"
                disabled={bonusBasisState?.disabled}
                options={[
                  {
                    value: 'company',
                    label: t('bonusBasisCompany', {
                      ns: 'forms',
                      basis: t(
                        COMPANY_DATA.applicationSettings?.isGrossBonus
                          ? 'bonusBasisGross'
                          : 'bonusBasisNet',
                        { ns: 'forms' }
                      ),
                    }),
                  },
                  {
                    value: 'gross',
                    label: t('bonusBasisGross', { ns: 'forms' }),
                  },
                  { value: 'net', label: t('bonusBasisNet', { ns: 'forms' }) },
                ]}
              />
            </Form.Item>
          )}

          {COMPANY_DATA.calculationSettings?.bonus &&
            COMPANY_DATA.bonusVariations?.enabled &&
            COMPANY_DATA.bonusVariations?.types?.length > 0 && (
              <VariationsInputSection
                form={form}
                title={t('bonusVariations', { ns: 'forms' })}
                types={COMPANY_DATA.bonusVariations.types}
                currency={
                  COMPANY_DATA.otherAllowancesData?.find(
                    (item) => item.inputName === 'bonus'
                  )?.currency
                }
                baseName="bonusVariations"
                disabled={readOnly}
              />
            )}

          {COMPANY_DATA.calculationSettings?.suspension &&
            COMPANY_DATA.suspensionVariations?.enabled &&
            COMPANY_DATA.suspensionVariations?.types?.length > 0 && (
              <VariationsInputSection
                form={form}
                title={t('suspensionVariations', { ns: 'forms' })}
                types={COMPANY_DATA.suspensionVariations.types}
                currency={
                  COMPANY_DATA.otherAllowancesData?.find(
                    (item) => item.inputName === 'suspension'
                  )?.currency
                }
                baseName="suspensionVariations"
                showDates={true}
                disabled={readOnly}
              />
            )}

          {COMPANY_DATA.calculationSettings?.nonMonetaryBenefit &&
            COMPANY_DATA.nonMonetaryBenefitVariations?.enabled &&
            COMPANY_DATA.nonMonetaryBenefitVariations?.types?.length > 0 && (
              <VariationsInputSection
                form={form}
                title={t('nonMonetaryBenefitVariations', { ns: 'forms' })}
                types={COMPANY_DATA.nonMonetaryBenefitVariations.types}
                currency={
                  COMPANY_DATA.otherAllowancesData?.find(
                    (item) => item.inputName === 'nonMonetaryBenefit'
                  )?.currency
                }
                baseName="nonMonetaryBenefitVariations"
                disabled={readOnly}
              />
            )}
        </div>
      )}
    </>
  );
}
